/**
 * Main Entry Point
 * Initializes the React application with i18n support and the
 * TanStack Query client (server-state cache for the whole portal).
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './i18n/config' // Initialize i18next
import App from './app'
import { queryClient } from './lib/query-client'
import { ToastViewport } from './components/toast/toast-viewport'
import { ConfirmDialogHost } from './components/confirm-dialog/confirm-dialog-host'

// In dev, expose the query client on window so it can be inspected from the
// browser console — `window.__queryClient__.getQueryCache().getAll()` etc.
// This replaces `@tanstack/react-query-devtools` which crashes on init under
// React 19 + StrictMode in this project.
if (import.meta.env.DEV) {
  (window as unknown as { __queryClient__: typeof queryClient }).__queryClient__ = queryClient;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* Mounted beside <App /> rather than inside it: app.tsx returns early
          for each portal mode, so anything rendered in there would disappear
          depending on which screen is showing. */}
      <ToastViewport />
      <ConfirmDialogHost />
    </QueryClientProvider>
  </StrictMode>,
)
